import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import { checkNotNullOrUndefinedOrEmtpy } from '@/services/utils'

import User from '@/services/users'

Vue.use(Vuex)

const STORAGE_HASH = 'Ax4XDbqIDE'
export const STORAGE_KEY = `constructcapital-${STORAGE_HASH}`

const COMPANY_INVESTMENTS_TABLE_FIELDS = [
  {
    key: 'company',
    label: 'Company',
    stickyColumn: true,
    thClass: 'sticky-column',
    tdClass: 'sticky-column--main',
  },
  { key: 'grossMoic', label: 'Gross MOIC' },
  { key: 'round', label: 'Round(s)' },
  { key: 'initialInvestmentDate', label: 'Initial Inv. Date' },
  { key: 'cost', label: 'Cost ($M)' },
  { key: 'fmv', label: 'FMV' },
  { key: 'ownership', label: 'Ownership (Initial/Current)' },
  { key: 'role', label: 'Role' },
  { key: 'coInvestors', label: 'Co-Investors' },
]
const INVESTMENTS_TABLE_FIELDS = [
  {
    key: 'investmentDate',
    label: 'Date',
  },
  { label: 'Val.(Post)', key: 'investmentValuation' },
  { label: 'Construct Inv', key: 'constructInvestment' },
  { label: 'FMV', key: 'investmentFmv' },
  { label: 'Ownership', key: 'investmentOwnership' },
  { label: 'MOIC', key: 'moic' },
  { label: 'Notes', key: 'investmentNotes' },
]
const state = {
  user: null,
  token: null,
  companyInvestmentsTableOpts: COMPANY_INVESTMENTS_TABLE_FIELDS,
  investmentsTableOpts: INVESTMENTS_TABLE_FIELDS,
  selectedFund: null,
  selectedFundRef: null,
}

const mutations = {
  UPDATE_USER: (state, opt) => {
    state.user = User.create(opt)
  },
  UPDATE_TOKEN: (state, opt) => {
    state.token = opt
  },
  LOGOUT_USER(state) {
    state.user = null
    state.token = null
    state.companyInvestmentsTableOpts = COMPANY_INVESTMENTS_TABLE_FIELDS
    state.investmentsTableOpts = INVESTMENTS_TABLE_FIELDS
    state.selectedFund = null
    state.selectedFundRef = null
  },
  SAVE_COMPANY_INVESTMENTS_TABLE_OPTS: (state, opt) => {
    // maintain order for now manually  based of designs
    let originalIndex = COMPANY_INVESTMENTS_TABLE_FIELDS.findIndex(f => f.key == opt)
    let currentIndex = state.companyInvestmentsTableOpts.findIndex(f => f.key == opt)

    if (~originalIndex && ~currentIndex) {
      state.companyInvestmentsTableOpts = [
        ...state.companyInvestmentsTableOpts.slice(0, currentIndex),
        ...state.companyInvestmentsTableOpts.slice(
          currentIndex + 1,
          state.companyInvestmentsTableOpts.length,
        ),
      ]
    } else if (~originalIndex && !~currentIndex) {
      state.companyInvestmentsTableOpts = [
        ...state.companyInvestmentsTableOpts,
        COMPANY_INVESTMENTS_TABLE_FIELDS[originalIndex],
      ]
    }
  },
  SAVE_INVESTMENTS_TABLE_OPTS: (state, opt) => {
    // maintain order for now manually  based of designs
    let originalIndex = INVESTMENTS_TABLE_FIELDS.findIndex(f => f.key == opt)
    let currentIndex = state.investmentsTableOpts.findIndex(f => f.key == opt)

    if (~originalIndex && ~currentIndex) {
      state.investmentsTableOpts = [
        ...state.investmentsTableOpts.slice(0, currentIndex),
        ...state.investmentsTableOpts.slice(currentIndex + 1, state.investmentsTableOpts.length),
      ]
    } else if (~originalIndex && !~currentIndex) {
      state.investmentsTableOpts = [
        ...state.investmentsTableOpts,
        INVESTMENTS_TABLE_FIELDS[originalIndex],
      ]
    }
  },
  RESET_COMPANY_INVESTMENTS_TABLE_OPTS: state => {
    state.companyInvestmentsTableOpts = COMPANY_INVESTMENTS_TABLE_FIELDS
  },
  RESET_INVESTMENTS_TABLE_OPTS: state => {
    state.investmentsTableOpts = INVESTMENTS_TABLE_FIELDS
  },
  SELECT_FUND: (state, opt) => {
    state.selectedFund = opt
  },
  SELECT_FUND_REF: (state, opt) => {
    state.selectedFundRef = opt
  },
}

const actions = {
  async refreshStoredUser({ state, commit }) {
    if (!state.token) {
      return User.create()
    }
    const res = await User.api.retrieve(state.user.id)

    commit('UPDATE_USER', res)
  },
}

const plugins = [
  createPersistedState({
    key: STORAGE_KEY,
  }),
]

const getters = {
  companyInvestmentsTableOpts: state => {
    return state.companyInvestmentsTableOpts
  },
  defaultCompanyInvestmentsTableOpts: state => {
    return COMPANY_INVESTMENTS_TABLE_FIELDS
  },
  investmentsTableOpts: state => {
    return state.investmentsTableOpts
  },
  defaultInvestmentsTableOpts: state => {
    return INVESTMENTS_TABLE_FIELDS
  },
  selectedFund: state => {
    return state.selectedFund
  },
  selectedFundRef: state => {
    return state.selectedFundRef
  },
  isLoggedIn: state => {
    if (checkNotNullOrUndefinedOrEmtpy(state.token) || checkNotNullOrUndefinedOrEmtpy(state.user)) {
      return false
    }
    return true
  },
  user: state => {
    return state.user
  },
  token: state => {
    return state.token
  },
}

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  plugins,
})
